import { ANDROID, IOS } from 'constants/platform';
import { canUseDOM } from './polyfills';

export const platform = (useragent) => {
  const ua = useragent || (canUseDOM && navigator.userAgent) || '';
  let OS;

  if (/android/i.test(ua)) {
    OS = ANDROID;
  }

  if (/iPad|iPhone|iPod/.test(ua)) {
    OS = IOS;
  }

  const isIOS = OS === IOS;
  const isAndroid = OS === ANDROID;

  return { OS, isIOS, isAndroid };
};
